import React, { PropTypes } from 'react'
import {List, ListItem} from 'material-ui/List'
import {Card, CardHeader, CardText} from 'material-ui/Card'
import {blue500, red500, grey500} from 'material-ui/styles/colors'

import ErrorIcon from 'material-ui/svg-icons/alert/error'
import Lens from 'material-ui/svg-icons/image/lens'

import RemoveCircle from 'material-ui/svg-icons/content/remove-circle'
import SwapVerticalCircle from 'material-ui/svg-icons/action/swap-vertical-circle'

const FLOAT_LEVEL_SWITCH_ROLE = 8

const getSubtitle = (floatLevelSwitch) => {
  if (floatLevelSwitch && floatLevelSwitch.updates.length > 0 && floatLevelSwitch.updates[0].data === 1) {
    return 'Risco de inundação'
  }
  return 'Em segurança'
}

const LevelItem = ({floatLevelSwitch}) => {
  const state = (floatLevelSwitch && floatLevelSwitch.updates.length > 0)
    ? floatLevelSwitch.updates[0].data === 1
    : false
  return (
    <ListItem
      primaryText="Nível"
      secondaryText={state ? 'Risco detectado' : 'Normal'}
      rightIcon={state ? <ErrorIcon color={red500} /> : <Lens color={blue500} />} />
  )
}

const BombItem = ({floatLevelSwitch}) => {
  const state = (floatLevelSwitch && floatLevelSwitch.updates.length > 0)
    ? floatLevelSwitch.updates[0].data === 1
    : false
  return (
    <ListItem
      primaryText="Bomba"
      secondaryText={state ? 'Ligada' : 'Desligada'}
      rightIcon={state ? <SwapVerticalCircle color={red500} /> : <RemoveCircle color={grey500} />} />
  )
}

const DryWell = ({informations, style}) => {
  const floatLevelSwitch = informations.find(information => information.role === FLOAT_LEVEL_SWITCH_ROLE)

  return (
    <Card style={{...style}}>
      <CardHeader
        title="Poço Seco"
        subtitle={getSubtitle(floatLevelSwitch)}
        textStyle={{ padding: 0 }}
        style={{ paddingBottom: 0 }} />
      <CardText>
        <List>
          <LevelItem floatLevelSwitch={floatLevelSwitch} />
          <BombItem floatLevelSwitch={floatLevelSwitch} />
        </List>
      </CardText>
    </Card>
  )
}

DryWell.propTypes = {
  informations: PropTypes.array.isRequired
}

export default DryWell



/** WEBPACK FOOTER **
 ** ./src/components/dashboard/DryWell.js
 **/